import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import {
  Button,
  Radio,
  Header,
  Main,
  Aside,
  Container,
  Menu,
  MenuItem,
  Submenu,
  MenuItemGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Card,
  Table,
  TableColumn,
  Breadcrumb,
  BreadcrumbItem,
  Tag,
  Form,
  FormItem,
  Input,
  Select,
  Switch,
  DatePicker,
  Option,
  Dialog,
  Pagination,
  Message,
  MessageBox,
  Image,
  Carousel,
  CarouselItem,
  Divider,
  Drawer,
  Collapse,
  CollapseItem,
  Link,
  RadioButton,
  RadioGroup,
  PageHeader,
  Backtop,
  Avatar,
  TabPane,
  Tabs
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import "lib-flexible"
import 'font-awesome/css/font-awesome.min.css'

import * as  animated  from 'animate.css'
Vue.use(animated)

Vue.config.productionTip = false
Vue.use(Button)
Vue.use(Radio)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Container)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tag)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Switch)
Vue.use(DatePicker)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Pagination)
Vue.use(Image)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Divider)
Vue.use(Drawer)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Link)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(PageHeader)
Vue.use(Backtop)
Vue.use(Avatar)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm

import util from './utils/tool.js'
 
Vue.prototype.$util=util 

router.beforeEach((to,from,next)=>{
      let isPc=util.isPc();
      // let w=document.documentElement.offsetWidth|| document.documentElement.clientWidth ;
      // if(w<1000)
      // {
      //    isPc=false;
      // }
      store.commit('changePcState',isPc);
      next();
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
